export const COMPANY_DETAILS = {
  name: "Royal Care Group",
  company: "Royal Care Group",
  legalName: "Royal Care Group Pty Ltd",
  division: "Tech Division",
  techDivisionName: "Tech Division",
  motto: "Structural Intelligence for NDIS",
  appVersion: "10.13.40-STABLE",
  buildDate: "2024-06-08 10:00 AEST",
  abn: "76 684 189 320",
  email: "Hello@royalcaregroup.com.au",
  emailGeneral: "Hello@royalcaregroup.com.au",
  address: "2/290 Boundary Street",
  cityStateZip: "Spring Hill QLD 4000",
  productionUrl: "https://www.royalcaregroup.com.au",
  cloudflareEndpoint: "rcg-website-8s2.pages.dev",
  googleAdsId: "AW-17820482706",
  socials: {
    linkedin: "https://linkedin.com/company/royalcaregroup"
  },
  colors: {
    neonPurple: '#d946ef',
    neonBlue: '#06b6d4',
    royal950: '#020817', 
    royal900: '#0f172a', 
    royal800: '#1e293b',
    statusGreen: '#10b981'
  },
  typography: {
    display: 'Outfit',
    body: 'Inter'
  }
};